<template>
  <div class="pa-3 pb-0" style="max-height: 80vh; overflow-y: scroll">
    <template v-if="activeFieldExpression.key == 'Title'">
      <div v-for="lang in language" :key="lang.key">
        <v-row class="px-4" :key="`${lang.key}-${lang.text}`">
          <v-text-field
            v-model="activeFieldExpression.value[lang.key]"
            v-if="lang.key == 'ja'"
            outlined
            dense
            :error-messages="activeFieldExpressionErrors"
            @input="$v.activeFieldExpression.value.ja.$touch()"
            @blur="$v.activeFieldExpression.value.ja.$touch()"
          >
            <template v-slot:label>
              <span class="font-weight-bold mr-1">{{ lang.text }}</span>
              <span class="red--text" v-if="lang.key == 'ja'">*</span>
            </template>
          </v-text-field>
          <v-text-field
            v-model="activeFieldExpression.value[lang.key]"
            v-else
            outlined
            dense
          >
            <template v-slot:label>
              <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            </template>
          </v-text-field>
        </v-row>
      </div>
    </template>

    <div v-if="activeFieldExpression.key == 'Example'">
      <div class="d-flex mb-5">
        <strong class="mt-1 mr-3">音声データ</strong>
        <audio id="Audio" :key="keyAudio" ref="audio">
          <source
            :src="
              activeFieldExpression.file
                ? activeFieldExpression.file.fileUrl
                : null
            "
            type="audio/mp3"
          />
          Your browser does not support the audio element.
        </audio>
        <v-btn
          color="warning"
          fab
          small
          height="25"
          width="25"
          style="margin-top: 3px"
          dark
          @click="play"
          v-if="
            activeFieldExpression.file && activeFieldExpression.file.fileUrl
          "
        >
          <v-icon size="15">fas fa-volume-up</v-icon>
        </v-btn>
        <v-spacer />
        <base-upload type="audio" v-model="activeFieldExpression.file">
          <span slot="activator">
            <v-btn small class="primary mr-1">{{ $t("FILE_SELECT") }}</v-btn>
          </span>
        </base-upload>
      </div>
    </div>
    <div
      v-if="
        activeFieldExpression.key == 'Explain' ||
        activeFieldExpression.key == 'Example'
      "
    >
      <v-row class="px-4" v-for="lang in language" :key="lang.key">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-if="lang.key == 'ja'"
          :error-messages="activeFieldExpressionErrors"
          @input="$v.activeFieldExpression.value.ja.$touch()"
          @blur="$v.activeFieldExpression.value.ja.$touch()"
          v-model="activeFieldExpression.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
            <span class="red--text" v-if="lang.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-else
          v-model="activeFieldExpression.value[lang.key]"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ lang.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixin";
export default {
  name: "Properties",
  mixins: [mixin.ValidateExpression],
  store: ["activeFieldExpression"], // Get the form data from Home
  watch: {
    activeFieldExpression: function (activeFieldExpression) {
      this.$v.$reset();
      console.log("activeFieldExpression: ", activeFieldExpression);
    },
    "activeFieldExpression.file": function () {
      this.keyAudio++;
    },
    "activeFieldExpression.fileUrl": function () {
      this.keyAudio++;
    },
  },
  data() {
    return {
      language: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      colors: ["#69BE5B", "#F26B68", "#262626"],
      typeTitle: [
        { text: "テキスト", value: "TEXT" },
        { text: "円形", value: "CIRCLE" },
      ],
      typeSentenceStructure: [
        { text: "テキスト", value: "TEXT" },
        { text: "ボックス", value: "BOX" },
      ],
      keyAudio: 0,
    };
  },

  methods: {
    handleCheckValidate() {
      this.$v.$touch();
      console.log("-------");
      return this.$v.$anyError;
    },
    play() {
      if (this.$refs.audio.paused) {
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.properties__optionslist {
  margin-bottom: 5px;
  list-style: none;
  list-style-type: none;
}
.properties__optionsul {
  padding: 0;
}
</style>
<style scoped>
button:focus {
  outline: none;
}
.is-active {
  border: 2.2px solid #555;
}
</style>